import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: '100%',
    height: '100%',
    paddingTop: '84px',
    paddingBottom: '100px'
  }
}));